import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/msglist'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/msglist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/operation/message/Msglist.vue'),
                    meta: { title: '短信列表' }
                },
                {
                    path: '/msgsend',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/operation/message/Msgsend.vue'),
                    meta: { title: '每日发送' }
                },
                {
                    path: '/applist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/operation/message/Applist.vue'),
                    meta: { title: '应用列表' }
                },
                {
                    path: '/msgblacklist',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/message/Msgblacklist.vue'),
                    meta: { title: '黑名单列表' }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
